import { useMemo, useState } from "react";
import { useProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import Reveal from "@/components/Reveal";

const FILTERS = ["all", "hoodies", "tees"];

export default function Shop() {
  const { products, loading } = useProducts();
  const [filter, setFilter] = useState("all");

  const list = useMemo(() => (filter === "all" ? products : products.filter((p) => p.category === filter)), [products, filter]);

  return (
    <div data-testid="shop-page" className="pt-24">
      <div className="border-b border-white/10 px-5 pb-10 pt-10 sm:px-8">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.35em] text-fade">THE CATALOG — {list.length} PIECES</p>
          <h1 className="mt-3 font-display text-5xl font-extrabold uppercase tracking-tight text-bone sm:text-7xl">Shop</h1>
        </Reveal>
        <div className="mt-8 flex flex-wrap gap-2">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`shop-filter-${f}`}
              onClick={() => setFilter(f)}
              className={`border px-4 py-2 font-mono text-[10px] uppercase tracking-[0.25em] transition-colors ${
                filter === f ? "border-bone bg-bone text-ink" : "border-white/15 text-bone/60 hover:border-white/40 hover:text-bone"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="flex h-96 items-center justify-center">
          <p className="font-mono text-xs tracking-[0.35em] text-fade">ALIGNING…</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 border-l border-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
